import * as Yup from 'yup'

export const contactTypeValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  contactCategoryId: Yup.number().min(1, 'Category is required').required('Category is required'),
})
